<template>
	<svg :width="this.$props.width" :height="this.$props.height" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20.0002 3.33325C29.2048 3.33343 36.6663 10.7956 36.6663 20.0002C36.6661 29.2047 29.2047 36.6661 20.0002 36.6663C10.7956 36.6663 3.33343 29.2048 3.33325 20.0002C3.33325 10.7955 10.7955 3.33325 20.0002 3.33325ZM20.0002 5.00024C11.716 5.00024 5.00024 11.716 5.00024 20.0002C5.00042 28.2844 11.7161 35.0002 20.0002 35.0002C28.2843 35.0001 35.0001 28.2843 35.0002 20.0002C35.0002 11.7161 28.2844 5.00042 20.0002 5.00024ZM25.2444 15.2444C25.5698 14.9189 26.0967 14.9189 26.4221 15.2444C26.7476 15.5698 26.7476 16.0967 26.4221 16.4221L18.0891 24.7561C17.7637 25.0814 17.2358 25.0815 16.9104 24.7561L13.5774 21.4221C13.2522 21.0967 13.2522 20.5698 13.5774 20.2444C13.9028 19.9189 14.4307 19.9189 14.7561 20.2444L17.5002 22.9885L25.2444 15.2444Z" :fill="this.$props.fill" />
	</svg>
</template>

<script>
export default {
  name: 'CheckmarkCircle',
  props: {
	width: {
	  type: [String, Number],
	  default: 40,
	},
	height: {
	  type: [String, Number],
	  default: 40,
	},
	fill: {
	  type: String,
	  default: 'white',
  	},
  },
};
</script>